import { Base } from "./Base";

export class WordpressPost extends Base {
    id: number;
    date: Date;
    date_gmt: Date;
    modified: Date;
    modified_gmt: Date;
    slug: string;
    status: string;
    type: string;
    link:string;
    title: WPTitle;
    content: WPContent;
    excerpt: WPExcerpt;
    author: number;
    featured_media: number;
    comment_status: string;
    ping_status: string;
    sticky: boolean;
    template: string;
    format: string;
    categories: number[];
    tags: number[];
    _links: WPLinks;
    cardImageLink: string;

    constructor(i?: IWordpressPost) {
        super();
        if(i) {
            Object.assign(this, i);
            this.date = new Date(i.date);
            this.date_gmt = new Date(i.date_gmt);
            this.modified = new Date(i.modified);
            this.modified_gmt = new Date(i.modified_gmt);
        }
    }

    toInterface(): IWordpressPost {
        var ret = {} as IWordpressPost;
        Object.assign(ret, this);
        return ret;
    }
}

export interface IWordpressPost {
    id: number;
    date: string;
    date_gmt: string;
    modified: string;
    modified_gmt: string;
    slug: string;
    status: string;
    type: string;
    link:string;
    title: WPTitle;
    content: WPContent;
    excerpt: WPExcerpt;
    author: number;
    featured_media: number;
    comment_status: string;
    ping_status: string;
    sticky: boolean;
    template: string;
    format: string;
    categories: number[];
    tags: number[];
    _links: WPLinks;
    cardImageLink: string;
}

export interface WPTitle {
    rendered: string;
}

export interface WPContent {
    rendered: string;
}

export interface WPDescription {
    rendered: string;
}

export interface WPExcerpt {
    rendered: string;
    protected: boolean;
}

export interface WPLinks {
    self: WPLink[];
    collection: WPLink[];
    about: WPLink[];
    author: WPLink[];
    replies: WPLink[];
    versionHistory: WPLink[];
    predecessorVersion: WPLink[];
    wpFeaturedmedia: WPLink[];
    wpAttachment: WPLink[];
    wpTerm: WPLink[];
    curies: WPLink[];
}

export interface WPLink {
    href: string;
    embeddable: boolean;
    count: number;
    id: number;
    taxonomy: string;
}

export interface WPMedia {
    id: number;
    date: string;
    date_gmt: string;
    modified: string;
    modified_gmt: string;
    slug: string;
    status: string;
    type: string;
    link:string;
    title: WPTitle;
    description: WPDescription;
    media_details: WPMediaDetails;
}

export interface WPMediaDetails {
    width: number;
    height: number;
    file: string;
    sizes: WPMediaSizes;
}

export interface WPMediaSizes{
    thumbnail: WPMediaSize;
    medium: WPMediaSize;
    medium_large: WPMediaSize;
    large: WPMediaSize;
    full: WPMediaSize;
}

export interface WPMediaSize {
    width: number;
    height: number;
    file: string;
    source_url: string;
    mime_type: string;
}